"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["forwardedRef", "showLabel", "type"],
    _excluded2 = ["fieldId", "forwardedRef", "handleBlur", "handleChange", "handleFocus", "hasLabel", "pattern", "showValue", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** String for input field id */
  fieldId: _propTypes.string,

  /** onBlur event handler - used to process the event */
  handleBlur: _propTypes.func,

  /** onChange event handler - used to process the event */
  handleChange: _propTypes.func,

  /** onFocus event handler - used to process the event */
  handleFocus: _propTypes.func,

  /** A boolean to check whether the input field has a label */
  hasLabel: _propTypes.bool,

  /** Pattern string to handle validation */
  pattern: _propTypes.string,

  /** A boolean to represent whether the value should be shown */
  showValue: _propTypes.bool,

  /** String for input field type */
  type: _propTypes.string
};
var BasicInput = (0, _styledComponents["default"])(function (_ref) {
  var forwardedRef = _ref.forwardedRef,
      showLabel = _ref.showLabel,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Input, _extends({
    ref: forwardedRef,
    type: type
  }, props));
}).withConfig({
  displayName: "input__BasicInput",
  componentId: "sc-1no6al1-0"
})(["appearance:none;background:transparent;border:none;font-family:inherit;outline:none;", ";transform:", ";transform-origin:0 0;", ";&::-ms-clear{display:none;}&::placeholder{color:", ";}", ";"], function (_ref2) {
  var type = _ref2.type;
  return type === "password" ? (0, _styledComponents.css)(["width:calc(100% - 50px);"]) : (0, _styledComponents.css)(["width:100%;"]);
}, function (_ref3) {
  var showLabel = _ref3.showLabel;
  return "translate3d(0, " + (showLabel ? "7px" : "0") + ", 0)";
}, (0, _styles.transitionEase)("0.3s", ["transform"]), function (props) {
  return (0, _styles.colors)("placeholder", props);
}, function (_ref4) {
  var type = _ref4.type;
  return type === "number" ? (0, _styledComponents.css)(["&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}"]) : null;
});

var Input = function Input(_ref5) {
  var fieldId = _ref5.fieldId,
      forwardedRef = _ref5.forwardedRef,
      handleBlur = _ref5.handleBlur,
      handleChange = _ref5.handleChange,
      handleFocus = _ref5.handleFocus,
      hasLabel = _ref5.hasLabel,
      pattern = _ref5.pattern,
      showValue = _ref5.showValue,
      type = _ref5.type,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded2);

  return /*#__PURE__*/_react["default"].createElement(BasicInput, _extends({
    id: fieldId
  }, _utils.defaultFontSize, _utils.defaultSpacing, {
    color: "text-title",
    fontWeight: 1,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    opacity: !hasLabel || showValue ? 1 : 0,
    pattern: pattern,
    forwardedRef: forwardedRef,
    showLabel: showValue && hasLabel,
    type: type,
    width: 1
  }, props));
};

Input.propTypes = propTypes;
BasicInput.displayName = "Modules.BasicInput";
var _default = Input;
exports["default"] = _default;